import { createContext, useContext, useState, useEffect } from "react";
import config from "../../../config";

const CreativeModuleContext = createContext(null);

const CreativeContextValues = ({ children }) => {

  const [isSelectCreative, setIsSelectCreative] = useState(false);

  return (
    <CreativeModuleContext.Provider
      value={{
        isSelectCreative,
        setIsSelectCreative,
      }}
    >
      {children}
    </CreativeModuleContext.Provider>
  );
};

export { CreativeContextValues, CreativeModuleContext };
